import { PANE_TRIGGER_SIZE } from '../constants/sizes';

const deriveItemsWidth = (items) =>
  items.reduce((totalWidth, { width }) => {
    const itemWidth = width || PANE_TRIGGER_SIZE;

    return totalWidth + itemWidth;
  }, 0);

export default deriveItemsWidth;
